<template>
  <Select
    ref="select"
    :model-value="modelValue"
    :options="options"
    :disabled="disabled"
    @focus="loadFonts"
    @update:model-value="updateValue"
    @update:open="loadFonts"
  >
    <template #selected="{ option }">
      <div
        class="mr-1 inline-grid size-5 place-items-center align-top text-muted-foreground"
        :style="{ fontFamily: option?.id }"
      >
        Aa
      </div>
      {{ " " }}
      <template v-if="option">
        {{ option.label }}
      </template>
      <template v-else>
        <span class="text-muted-foreground">Inherit</span>
      </template>
    </template>

    <template #option="{ option }">
      <div
        class="mr-1 inline-grid size-5 place-items-center align-top text-muted-foreground"
        :style="{ fontFamily: option.id }"
      >
        Aa
      </div>

      {{ option.label }}
    </template>
  </Select>
</template>

<script lang="ts">
let hasLoadedFonts = false;

const loadFonts = () => {
  if (hasLoadedFonts) {
    return;
  }

  hasLoadedFonts = true;

  void Promise.allSettled([
    // Variable fonts
    import("@fontsource-variable/alegreya"),
    import("@fontsource-variable/alegreya/wght-italic.css"),
    import("@fontsource-variable/cabin"),
    import("@fontsource-variable/cabin/wght-italic.css"),
    import("@fontsource-variable/eb-garamond"),
    import("@fontsource-variable/eb-garamond/wght-italic.css"),
    import("@fontsource-variable/figtree"),
    import("@fontsource-variable/figtree/wght-italic.css"),
    import("@fontsource-variable/lora"),
    import("@fontsource-variable/lora/wght-italic.css"),
    import("@fontsource-variable/merriweather"),
    import("@fontsource-variable/merriweather/wght-italic.css"),
    import("@fontsource-variable/montserrat"),
    import("@fontsource-variable/montserrat/wght-italic.css"),
    import("@fontsource-variable/source-serif-4"),
    import("@fontsource-variable/source-serif-4/wght-italic.css"),
    // Regular fonts
    import("@fontsource/aleo/400.css"),
    import("@fontsource/aleo/400-italic.css"),
    import("@fontsource/aleo/700.css"),
    import("@fontsource/aleo/700-italic.css"),
    import("@fontsource/ibm-plex-mono/400.css"),
    import("@fontsource/ibm-plex-mono/400-italic.css"),
    import("@fontsource/ibm-plex-mono/500.css"),
    import("@fontsource/ibm-plex-mono/600.css"),
    import("@fontsource/ibm-plex-mono/700.css"),
    import("@fontsource/ibm-plex-mono/700-italic.css"),
    import("@fontsource/lato/400.css"),
    import("@fontsource/lato/400-italic.css"),
    import("@fontsource/lato/700.css"),
    import("@fontsource/lato/700-italic.css"),
  ]);
};
</script>

<script lang="ts" setup>
import { computed, useTemplateRef } from "vue";

import Select, { type SelectOption } from "./Select.vue";

const modelValue = defineModel<string>({ default: "" });

defineProps<{
  options: readonly SelectOption[];
  disabled?: boolean;
}>();

const select = useTemplateRef("select");

const updateValue = (next: string) => {
  modelValue.value = next;
};

defineExpose({
  input: computed(() => select.value?.input),
});
</script>
